import React, { useEffect, useState } from "react";
import Layout from "../../utils/layout";
import { Link } from "react-router-dom";
import CategoryModal from "./CategoryModal";
import RemoveCategoryModal from "./RemoveCategoryModal";
import CategoryRow from "./CategoryRow";
import { observer } from "mobx-react";
import useStore from "../../hooks/useStore";

const Categories = () => {
  const [showCategoryModal, setshowCategoryModal] = useState(false);
  const [showDeleteModal, setShowDeleteCategory] = useState(false);
  const [mode, setMode] = useState("");
  const [updateCategory, setUpdateCategory] = useState(null);
  const {
    dashboardStore: {
      categoryList,
      fetchCategories,
      filterCategories,
      searchCategory,
    },
    userStore: { userData },
  } = useStore();
  const handleNewCategory = () => {
    setshowCategoryModal(!showCategoryModal);
    setMode("create");
  };

  const handleDeleteCategory = () => {
    setShowDeleteCategory(true);
  };

  const handleEditCategory = (category) => {
    setshowCategoryModal(!showCategoryModal);
    setMode("edit");
    setUpdateCategory(category);
  };

  const handleCloseNewCategoryMdoal = () => {
    setshowCategoryModal(false);
    setUpdateCategory(null);
  };

  const handleCloseDeleteCategoryMdoal = () => {
    setShowDeleteCategory(!showDeleteModal);
  };

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return (
    <Layout>
      <div className="categories">
        <div className="container-fluid">
          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Categories</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link
                        to={
                          userData.role === "owner"
                            ? "/admin/dashboard"
                            : "/company/dashboard"
                        }
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Categories</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* End Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-sm-4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <input
                            type="text"
                            className="form-control"
                            id="searchTableList"
                            placeholder="Search..."
                            value={searchCategory}
                            onChange={(event) =>
                              filterCategories(event.target.value)
                            }
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="text-sm-end">
                        {/* <button
                          type="button"
                          onClick={handleNewCategory}
                          data-bs-toggle="modal"
                          data-bs-target="#newCustomerModal"
                          className="btn btn-success waves-effect waves-light mb-2 me-2 addCustomers-modal"
                        >
                          <i className="mdi mdi-plus me-1"></i> New Category
                        </button> */}
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive ">
                                <table className="table align-middle table-bordered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Name</th>
                          <th>Slug</th>
                          <th>Position</th>
                          <th>Create Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(categoryList) &&
                          categoryList?.map((category, id) => {
                            return (
                              <CategoryRow
                                handleDeleteCategory={handleDeleteCategory}
                                handleEditCategory={() =>
                                  handleEditCategory(category)
                                }
                                category={category}
                                key={id}
                                index={id + 1}
                              />
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CategoryModal
        open={showCategoryModal}
        onClose={handleCloseNewCategoryMdoal}
        mode={mode}
        initialState={updateCategory}
      />
      <RemoveCategoryModal
        open={showDeleteModal}
        onClose={handleCloseDeleteCategoryMdoal}
      />
    </Layout>
  );
};

export default observer(Categories);
